import { XHR, getHeaders } from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';
import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import DigitalWalletStore from './DigitalWalletStore';
import { clickIdTracker } from '../../utils/TrackingUtils';

function getBaseUrl() {
  return OlsConfigStore.getApiBaseUrl();
}

function checkoutUrl(order) {
  return `${getBaseUrl()}/api/checkouts/${order.number}?app=vnext`;
}

function ordersUrl(order) {
  return `${getBaseUrl()}/api/orders/${order.number}/apply_coupon_code`;
}

function shippingMethodsUrl() {
  return `${getBaseUrl()}/api/v1/shipping_methods`;
}

export function updateCartShipAddress(order, shippingAddress) {
  const timeout = OlsConfigStore.getState().requestTimeout.default;
  return XHR.putRequest(
    checkoutUrl(order),
    {
      order: {
        alternative_attributes: {
          payment_request: {
            email: null,
            ship_address_attributes: shippingAddress,
            bill_address_attributes: 'same_as_ship_address'
          }
        }
      }
    },
    timeout,
    getHeaders(order)
  );
}

export function updateCartShipMethod(order, shippingOption) {
  const timeout = OlsConfigStore.getState().requestTimeout.default;
  return XHR.putRequest(
    checkoutUrl(order),
    {
      order: {
        alternative_attributes: {
          payment_request: {
            shipments_attributes: {
              selected_shipping_rate_id: shippingOption.id
            }
          }
        }
      }
    },
    timeout,
    getHeaders(order)
  );
}

function createTrackingHeaders(headers) {
  const [gclid, gdanclid, fbc, fbp] = [
    clickIdTracker.getGoogleClickId(),
    clickIdTracker.getGdanClidValue(),
    clickIdTracker.getFacebookClickId(),
    clickIdTracker.getFacebookBrowserId()
  ];

  return {
    ...headers,
    ...(gclid && { 'X-GCLID': gclid }),
    ...(gdanclid && { 'X-GDANCLID': gdanclid }),
    ...(fbc && { 'X-FBC': fbc }),
    ...(fbp && { 'X-FBP': fbp })
  };
}

export async function completePoyntOrder(order, nonce, initPage, paymentMethod) {
  const timeout = OlsConfigStore.getState().requestTimeout.default;
  const { shippingAddress, billingAddress } = order;

  const headers = createTrackingHeaders(getHeaders(order));

  return XHR.putRequest(
    checkoutUrl(order),
    {
      do_not_set_state: true,
      order: {
        payment_init_page: initPage,
        payments_attributes: [
          {
            amount: order.balance_due,
            payment_method_list_type: paymentMethod,
            source_attributes: {
              gateway_payment_profile_id: nonce
            }
          }
        ],
        alternative_attributes: {
          poynt_payment_request: {
            email: shippingAddress.emailAddress,
            bill_address_attributes: billingAddress,
            ship_address_attributes: shippingAddress
          }
        }
      }
    },
    timeout,
    headers
  );
}

export function completeOrder(order, result, initPage) {
  const timeout = OlsConfigStore.getState().requestTimeout.default;
  const { applePayIsSupported } = DigitalWalletStore.getState();

  return XHR.putRequest(
    checkoutUrl(order),
    {
      order: {
        payment_init_page: initPage,
        payments_attributes: [
          {
            payment_method_list_type: applePayIsSupported ? 'apple' : 'google'
          }
        ],
        alternative_attributes: {
          payment_request: {
            email: result.payerEmail,
            ship_address_attributes: result.shippingAddress,
            bill_address_attributes: result.token.card,
            payments_attributes: result.token
          }
        }
      }
    },
    timeout,
    getHeaders(order)
  );
}

export function applyCoupon(order, couponCode) {
  const timeout = OlsConfigStore.getState().requestTimeout.default;
  const couponParams = {
    coupon_code: couponCode
  };

  return XHR.putRequest(ordersUrl(order), couponParams, timeout, getHeaders(order));
}

export function fetchShippingMethods() {
  const timeout = OlsConfigStore.getState().requestTimeout.default;
  return XHR.getRequest(shippingMethodsUrl(), {}, timeout, getHeaders({}));
}
